import axios, { InternalAxiosRequestConfig } from 'axios';
import { Auth } from 'aws-amplify';
import { BusinessUnits } from 'src/enums/enum';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_BASE_URL_MOCK = 'https://4a94e40f-f6a6-424b-9323-dccc77a7d0a0.mock.pstmn.io/frame/';
export const FRAME_SVC_API_KEY = process.env.REACT_APP_FRAME_SVC_API_KEY;

export type RequestHeaders = {
  'Content-Type': string;
  Authorization: string;
  'x-api-key': string;
};
export const headers = {
  'Content-Type': 'application/json',
  'x-api-key': FRAME_SVC_API_KEY,
};

export const buParam = {
  bu: BusinessUnits.GB,
};
export const params = {
  ...buParam,
  offset: 0,
  limit: 50,
};

export const API_ENDPOINTS = {
  TOC_POC_SEARCH_URL: `${API_BASE_URL}ooc/search`,
  OOC_SEARCH_URL_FOR_CREATE_MODAL: `${API_BASE_URL}ooc/search_for_create_update`,
  AUTO_SUGGEST_URL: `${API_BASE_URL}v2/suggest`,
  CREATE_TOC_URL: `${API_BASE_URL}toc`,
  UPDATE_TOC_URL: `${API_BASE_URL}toc`,
  DELETE_TOC_URL: `${API_BASE_URL}toc`,
  OOC_SYNC_HISTOEY: `${API_BASE_URL}ooc/sync_history`,
  CREATE_POC_URL: `${API_BASE_URL}poc`,
  AUDIT_SEARCH: `${API_BASE_URL}ooc/audit_search`,
  ALL_USERS_SEARCH: `${API_BASE_URL}user`,
  USER_SEARCH: `${API_BASE_URL}user/search`,
  TOC_RESYNC: `${API_BASE_URL}toc/resync`,
  POC_RESYNC: `${API_BASE_URL}poc/resync`,
  TOC_REASONS: `${API_BASE_URL}toc/reasons`,
  OOC_BULK_SEARCH: `${API_BASE_URL}ooc/search/bulk`,
  VALIDATE_BULK_TOC_UPDATE: `${API_BASE_URL}toc/bulk/validate`,
  SUBMIT_BULK_TOC_UPDATE: `${API_BASE_URL}toc/bulk/update`,
  TOC_BULK_UPDATE_SUMMARY: `${API_BASE_URL}toc/bulk/update/summary`,
  TOC_BULK_UPDATE_DETAIL: `${API_BASE_URL}toc/bulk/update/detail`,
  TRIGGER_OOC_DOWNLOAD: `${API_BASE_URL}ooc/search/download/trigger`,
  OOC_DOWNLOAD_STATUS: `${API_BASE_URL}ooc/search/download/status`,
  FRAME_SEARCH_REQUEST: `${API_BASE_URL}v2/websearch`,
  V2_DISTINCT: `${API_BASE_URL}v2/distinct`,
  OPENING_HOURS_SEARCH_REQUEST: `${API_BASE_URL}fs/search`,
  OH_RESYNC: `${API_BASE_URL}fs/op/resync`,
};

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': FRAME_SVC_API_KEY,
    Authorization:
      'Bearer eyJraWQiOiJFYlVsNW1xUzJ0RmRNelJnaDBDVllpNkh4WFVrbTM5YkRcLzZRU08yeTI2RT0iLCJhbGciOiJSUzI1NiJ9.eyJhdF9oYXNoIjoiRHJDdDJtV3NjZ0lHcEVra0EwcFBuUSIsInN1YiI6ImViNTNmYmQ0LTdmMDAtNDk0Mi05NGRkLWI5MjgxOGYyZjliNiIsInpvbmVpbmZvIjoiVUsiLCJjdXN0b206YnVzaW5lc3N1bml0IjoiVUsiLCJjb2duaXRvOmdyb3VwcyI6WyJldS13ZXN0LTFfaXFUaGRwNHRSX2F6dXJlSWRwIl0sImN1c3RvbTpwcmluY2lwYWxOYW1lIjoidXRrYXJzaC5zaW5naEBjbGVhcmNoYW5uZWwuY28udWsiLCJjdXN0b206am9idGl0bGUiOiJEZXZlbG9wZXIiLCJjdXN0b206Zmlyc3RuYW1lIjoiVXRrYXJzaCIsImN1c3RvbTpkZXBhcnRtZW50IjoiVGVjaCAtIFNvZnR3YXJlIERlbGl2ZXJ5IiwiaXNzIjoiaHR0cHM6XC9cL2NvZ25pdG8taWRwLmV1LXdlc3QtMS5hbWF6b25hd3MuY29tXC9ldS13ZXN0LTFfaXFUaGRwNHRSIiwiY3VzdG9tOmVtYWlsIjoidXRrYXJzaC5zaW5naEBjbGVhcmNoYW5uZWwuY28udWsiLCJjdXN0b206Y29tcGFueW5hbWUiOiJDbGVhciBDaGFubmVsIFVLIiwiY3VzdG9tOnVzZXJpZCI6IjJkYjU3ZDE4LTNiOTYtNDFhMC1hMDc1LWI2ZDQ2YjM0YTI1OCIsImlkZW50aXRpZXMiOlt7InVzZXJJZCI6InV0a2Fyc2guc2luZ2hAY2xlYXJjaGFubmVsLmNvLnVrIiwicHJvdmlkZXJOYW1lIjoiYXp1cmVJZHAiLCJwcm92aWRlclR5cGUiOiJTQU1MIiwiaXNzdWVyIjoiaHR0cHM6XC9cL3N0cy53aW5kb3dzLm5ldFwvMTYyM2UwOGItYWNhMS00OWM2LWI1NzctODljNWJkNGFhN2I0XC8iLCJwcmltYXJ5IjoidHJ1ZSIsImRhdGVDcmVhdGVkIjoiMTY5NDkzMzYxMjcxNCJ9XSwiYXV0aF90aW1lIjoxNjk3ODg1NzYwLCJjdXN0b206bGFzdG5hbWUiOiJTaW5naCIsImV4cCI6MTY5Nzg4NjQ3MCwiaWF0IjoxNjk3ODg2MTcwLCJqdGkiOiJiNGY2YmU2NS1kMTFlLTQ4OWMtYjc3OC01M2FjMmZkN2U0ODMiLCJlbWFpbCI6InV0a2Fyc2guc2luZ2hAY2xlYXJjaGFubmVsLmNvLnVrIiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJhZGRyZXNzIjp7ImZvcm1hdHRlZCI6IjJkYjU3ZDE4LTNiOTYtNDFhMC1hMDc1LWI2ZDQ2YjM0YTI1OCJ9LCJjb2duaXRvOnVzZXJuYW1lIjoiYXp1cmVJZHBfdXRrYXJzaC5zaW5naEBjbGVhcmNoYW5uZWwuY28udWsiLCJnaXZlbl9uYW1lIjoiVXRrYXJzaCIsIm9yaWdpbl9qdGkiOiJiOTFiNzM5YS0yYzU1LTQ4ODYtOTBmNi03MTNmYjg0NjliMWEiLCJhdWQiOiI2bWdsNW1kNmdka2QyM3M1dDMydHU0M2pmaSIsInRva2VuX3VzZSI6ImlkIiwibmFtZSI6InV0a2Fyc2guc2luZ2hAY2xlYXJjaGFubmVsLmNvLnVrIiwiZmFtaWx5X25hbWUiOiJTaW5naCJ9.g2tKTrZ8_uehO97CGZ4ArHJyPI5OxJ-uEGXiTWoGTT5TgCVpy3Y2GUJhXwY_RbGFUMwrui6-piKfr46eSLenBAwRSaO1IZ9IoZZ845f-vPD_kOEgoUbTnASmMAUFKV-_qTtWEfTGrwSHCS8YAZTmoM7i6OJsouPnl3oWLMJ5nqvMAGCtAVUNcAS20aBU4y1Fqjd0f0Ofp4CYZLYrZOqjz8HXnJEOGm8IqhUWy6dpD4cHW72tFJxMYeAIKYpfdexoNR5UWjR-knRDLBqIKuZKSWp3NNP60PC-gx810NPrseY2gcWqfSc5NJr5vyYjnIBtEulsLcojuW8pLOfJsmBKBw',
  },
});

const refreshToken = async () => {
  try {
    const currentSession = await Auth.currentSession();
    const idToken = currentSession.getIdToken().getJwtToken();
    return idToken;
  } catch (error) {
    return Promise.reject(error);
  }
};

api.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const idToken = await refreshToken();
    config.headers['Content-Type'] = 'application/json';
    config.headers.Authorization = `Bearer ${idToken}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export function getGoogleMapsURL(latitude: number | null, longitude: number | null) {
  return `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${latitude},${longitude}&heading=-45&pitch=0&fov=80`;
}
